import { LeadApiRecord } from "./LeadTableDataGrid"
import { LeadRow } from "./leadTableTypes"

export function mapLeadToRow(record: LeadApiRecord): LeadRow {
  const a = record.attributes ?? {}

  return {
    id: record.id,
    createdAt: a['created-at'] ?? null,
    clientId: a['client-id'] ?? null,
    clientCampaignId: a['client-campaign-id'] ?? null,
    campaignPublicId: a['campaign-public-id'] ?? null,
    degreeProgramId: a['degree-program-id'] ?? null,
    subId: a.subid ?? null,
    source: a.source ?? null,
    firstName: a['first-name'] ?? null,
    lastName: a['last-name'] ?? null,
    email: a.email ?? null,
    phoneNumber: a.phone ?? null,
    streetAddress: a['street-address'] ?? null,
    city: a.city ?? null,
    state: a.state ?? null,
    zipCode: a['zip-code'] ?? null,
    status: a.status ?? null,
    statusCode: a['status-code'] ?? null,
    disposition: a.disposition ?? null,
    billable: Boolean(a.billable),
    rejectionReason: a['rejection-reason'] ?? null,
    filteredReason: a['filtered-reason'] ?? null,
    publicId: a['public-id'] ?? null,
    test: Boolean(a.test),
    statusChangedAt: a['status-changed-at'] ?? null,
    vendorId: a['vendor-id'] ?? null,
    externalId: a['external-id'] ?? null,
    costInCents: a['cost-in-cents'] ?? null,
    ipAddress: a['remote-ip'] ?? null,
    userAgent: a['user-agent'] ?? null,
    secondaryTcpa: Boolean(a['secondary-tcpa']),
    rawRequestParameters: a['raw-params'] ?? null,
    trackingParameters: a['tracking-params'] ?? null,
    landingPageId: a['landing-page-id'] ?? null,
    clientCampaignCustomAttributes: a['client-campaign-custom-attributes'] ?? {},
    customFields: a['custom-fields'] ?? {},
    jornayaLeadidToken: a['jornaya-leadid-token'] ?? null,
    complyedCreativeId: a['complyed-creative-id'] ?? null,
  }
}
